export default (Alpine) => {
    Alpine.directive(
        "seline",
        (element, { value, modifiers, expression }, { evaluateLater, cleanup }) => {
            if (value !== "click") return;

            const evaluateEvent = evaluateLater(expression);
            const onClick = (event) => {
                evaluateEvent(
                    (trackingEvent) => {
                        const { name: eventName, value: eventValue } = trackingEvent ?? {};
                        console.log(eventName, eventValue);

                        if (typeof eventName === "string" && eventName.trim()) {
                            window.seline?.track(eventName, eventValue);
                        }
                    },
                    { scope: { $event: event }, params: [event] },
                );
            };

            const eventDirective = [Alpine.prefixed("on:click"), ...modifiers].join(".");
            cleanup(Alpine.bind(element, { [eventDirective]: onClick }));
        },
    );
};
